<template>
    <design-2021-apprentice-video-player-component :options="playerOptions" :height="height">
    </design-2021-apprentice-video-player-component>
</template>

<script>
    export default {
        name: "design-2021-apprentice-video-link-player-component",
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            },
            height:  {
                type: Number,
                required: false,
                default: 0,
            },
            src:  {
                type: String,
                required: false,
                default: '',
            }
        },

        data () {
            return {
                youtubeOptions:{
                    techOrder: [this.getSourceType()],
                    sources: [{
                        type: `video/${this.getSourceType()}`,
                        src: this.src
                    }]
                },
            }
        },

        computed: {
            playerOptions () {
                return Object.assign(this.youtubeOptions, this.options);
            }
        },

        methods: {
            getSourceType(){
                if(this.src.toLowerCase().indexOf('vimeo') !== -1) {
                    return 'vimeo';
                } else {
                    return 'youtube';
                }
            }
        }
    }
</script>

<style scoped>

</style>
